import { render, staticRenderFns } from "./PayOrderSuccess.vue?vue&type=template&id=af54a768&"
import script from "./PayOrderSuccess.vue?vue&type=script&lang=ts&"
export * from "./PayOrderSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./PayOrderSuccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports